module.exports = __webpack_public_path__ + "img/logo_un_funded_es.11bdbc0.png";